import {
  gtmScreenName,
  trackEventBuyer,
  trackEventBuyerWithExtraParams,
  trackEventSeller,
  trackEventWithNoCategory,
  trackVirtualPageView,
} from "GTMs/libs";

export const gtmAddPostBtnHeader = () => {
  trackEventSeller("InitAddPost", `AddPostBtn_TopBar`);
};

export const gtmLoginTopBarBtn = () => {
  trackEventWithNoCategory("InitLogin", `LoginBtn_TopBar`);
};

export const gtmFollowButton = (eventAction, eventLabel = "FollowBtn") => {
  if (gtmScreenName === "PostViewScreen") {
    trackEventBuyer(eventAction, eventLabel);
  } else {
    trackEventWithNoCategory(eventAction, `${eventLabel}`);
  }
};

export const gtmFavoriteBtn = (eventAction , extraData) => {
  if (gtmScreenName === "PostViewScreen") {
    trackEventBuyerWithExtraParams(eventAction, `FavBtn` , extraData );
  } else {
    trackEventBuyerWithExtraParams(eventAction, `Fav_PostCell` , extraData);
  }
};

export const gtmSearchBtnHeader = () => {
  if (gtmScreenName === "HomeScreen") {
    trackEventBuyer("InitSearch", `SearchBtn`);
  } else {
    trackEventBuyer("InitSearch", `FindBtn`);
  }
};

export const gtmSearchForUserName = () => {
  trackEventBuyer("SearchByUserName", 'ExtraSearchCell_SearchScreen');
};

export const gtmReportButton = () => {
  if(gtmScreenName === "PostGalleryScreen"){
    trackEventBuyer("InitReport", `ReportPostBtn_Menu_PostGalleryScreen`,true);
  }else if (gtmScreenName === "PostViewScreen") {
    trackEventBuyer("InitReport", `ReportPostBtn`);}
   else{
    trackEventBuyer("InitReport", `ReportMemberBtn`)
  }
};

export const gtmFavoriteTopBtn = (eventAction) => {
  trackEventBuyer(eventAction, `FavBtn_TopBar`);
};

export const gtmLoginBtn = () => {
  switch (gtmScreenName) {
    case "HomeScreen":
      trackEventWithNoCategory("InitLogin", "LoginBtn", null, false);
      break;
    case "SearchScreen":
      trackEventWithNoCategory("InitLogin", "LoginBtn_TopBar");
      break;
  }
};

export const gtmLanguageBtn = () => {
  trackEventBuyer("ChooseLang", "EnglishBtn");
};

export const gtmHeaderCategories = () => {
  trackEventBuyer("Browse", "CategoryCell");
};

export const gtmFilterCategories = () => {
  trackEventBuyer("InitChooseCategory", "CategoryBtn");
};
export const gtmSortCellSearchScreen = () => {
  trackEventBuyer("Sorting", "SortCell_SearchScreen");
};

export const gtmFilterCities = () => {
  trackEventBuyer("InitChooseCity", "CityBtn_SearchScreen");
};

export const gtmOnChangeKeyword = () => {
  trackEventBuyer("Search", "SearchTF_AutoCompleteScreen");
};

export const gtmOnKeywordSubmit = () => {
  trackEventBuyer("Search", `SearchTF_AutoCompleteScreen`);
};

export const gtmRecentSearchAutoComplete = () => {
  trackEventBuyer("Search", `RecentSearch_AutoCompleteScreen`);
};

export const gtmSavedSearchAutoComplete = () => {
  trackEventBuyer("Search", `SavedSearch_AutoCompleteScreen`);
};

export const gtmTagAutoComplete = () => {
  trackEventBuyer("Search", `TagsSearch_AutoCompleteScreen`);
};

export const gtmMostUsedSearch = () => {
  trackEventBuyer("Search", "TopSearch");
};

export const gtmAutoCompleteShowScreen = () => {
  trackVirtualPageView("AutoCompleteScreen");
};

export const gtmAutoCompleteCellTap = () => {
  trackEventBuyer("Search", "AutocompleteCell_AutoCompleteScreen");
};

export const gtmContactUsFooter = () => {
  trackEventWithNoCategory("InitContactUs", "ContactUsBtn");
};

export const gtmNotificationHeader = () => {
  trackEventWithNoCategory("Browse", "NotificationBtn");
};

export const gtmNoResultsDisplay = () => {
  trackEventBuyer("BrowseNoResult", "NoResult_SearchScreen_ZeroResults");
};
export const gtmNoRecommandationAdsDisplay = () => {
  trackEventBuyer("BrowseNoResult", "NoResult_SearchScreen_RecommendedResults");
};
/******************************************************************/
export const gtmAddPostBtnBottomBar = (e) => {
  trackEventSeller("InitAddPost", "AddPostBtn_BottomBar");
};

export const gtmBackArrow = (e) => {
  trackEventBuyer("Back", "BackBtn");
};

export const gtmAdsSearch = (e) => {
  switch (gtmScreenName) {
    case "ShopsListingScreen":
    case "ShopScreen":
      trackEventBuyer("ShopsSearch", "SearchTF");
      break;
    case "MidScreen":
      trackEventBuyer("MidSearch", "SearchTF");
      break;
    default:
      return;
  }
};

export const gtmDownloadApp = (type: "iOS" | "Android" | "Huawei") => {
  trackEventWithNoCategory("AppDownload", `${type}AppBtn_BottomBar`);
};

export const gtmBrokenImage = () => {
  trackEventBuyer("BrokenImage", `BrokenImageView_${gtmScreenName}`);
};

export const gtmAddPostBtnWidgetSeller = () => {
  trackEventSeller("InitAddPost", `AddPostBtn_AddListingWidget_${gtmScreenName}`);
};

export const gtmOpenShopBtnWidgetSeller = () => {
  trackEventSeller("InitAddShop", `AddShopBtn_GetMoreListingsWidget_${gtmScreenName}`);
};